module.exports = __webpack_public_path__ + "static/nagra-6cc49b5ef1672bd5ce98480714c8dd52.jpg";